import React, { useEffect, useState } from 'react'
import { Container, Row } from 'react-bootstrap'
import Header from '../../../src/customerpanel/components/Header'
import { Navigate } from 'react-router-dom';
import moment from 'moment';
import { DataGrid } from '@mui/x-data-grid';
import Paper from '@mui/material/Paper';
const Invoice = () => {
  const [loading, setLoading] = useState(true);
  const [dgrlist, setDgrlist] = useState([]);

  const fetchData = async () => {
    try {
      const customerId = localStorage.getItem("customerId");
      //const customerId = "520cdd307940c5968fddd52a61d08bdb";
      const response = await fetch("https://api.srivarugreenenergy.com/customerapi/daily_generations/list.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            user_id: customerId
          }),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }
      const responseData = await response.json();
      setLoading(false);
      if (responseData.status === 200) {
        const reversedData = responseData.data.daily_generation;
        setDgrlist(reversedData);
      } else {
        throw new Error(responseData.msg);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching data:", error.message);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  const [isLoggedIn, setIsLoggedIn] = useState(true);
  useEffect(() => {
    const checkSession = async () => {
      try {
        // Check session logic here, e.g., fetch from local storage or server
       
        const customerId = localStorage.getItem("customerId");
        if (!customerId) {
          setIsLoggedIn(false);
        }
      } catch (error) {
        console.error('Error checking session:', error.message);
        setIsLoggedIn(false);
      }
    };
    checkSession();
  }, []);

  const columns = [
    { field: 'id', headerName: 'S.No', width: 70 },
    {
      field: 'dg_date',
      headerName: 'Date',
      width: 130,

    },
    { field: 'wtg_no', headerName: 'WEG No.', width: 130 },
    { field: 'location_no', headerName: 'Loc. No', width: 130 },
    { field: 'total_production', headerName: 'Total Production', width: 180 },
    { field: 'gen_hourtotal', headerName: 'Gen Hrs', width: 130, },
    { field: 'kwh_imp', headerName: 'KWH Import EB', width: 180 },
    { field: 'kwh_exp', headerName: 'KWH Export EB', width: 180 },
    { field: 'kvarh_imp', headerName: 'Kvarh Imp EB', width: 180 },
    { field: 'kvarh_exp', headerName: 'Kvarh Exp EB', width: 180 },
    { field: 'error_overtotal', headerName: 'M/c Fault hrs', width: 180, },
    { field: 'maintenance_overtotal', headerName: 'M/c Maintenance hrs', width: 180, },
    { field: 'gridfault_overtotal', headerName: 'Grid Fault hrs', width: 180, },
    { field: 'griddrop_overtotal', headerName: 'Grid Down hrs', width: 180, },
    { field: 'lull_hrs', headerName: 'Lull hrs', width: 180, },
    { field: 'machine_availability', headerName: 'M/c Availability', width: 180, type: 'number' },
    { field: 'grid_availability', headerName: 'Grid Availability', width: 180, type: 'number' },
    { field: 'kvarh_imp_per', headerName: 'Kvarh Imp %', width: 180, type: 'number' },
  ];

  const rows = dgrlist.map((data, index) => ({
    id: index + 1,
    dg_date: data.dg_date ? moment(data.dg_date).format('DD-MM-YYYY') : 'N/A',
    wtg_no: data.wtg_no,
    location_no: data.location_no,
    total_production: data.total_production,
    gen_hourtotal: data.gen_hourtotal || '00:00',
    kwh_imp: data.kwh_imp || 0,
    kwh_exp: data.kwh_exp || 0,
    kvarh_imp: data.kvarh_imp || 0,
    kvarh_exp: data.kvarh_exp || 0,
    error_overtotal: data.error_overtotal || '00:00',
    maintenance_overtotal: data.maintenance_overtotal || '00:00',
    gridfault_overtotal: data.gridfault_overtotal || '00:00',
    griddrop_overtotal: data.griddrop_overtotal || '00:00',
    lull_hrs: data.lull_hrs || '00:00',
    machine_availability: data.machine_availability || 0,
    grid_availability: data.grid_availability || 0,
    kvarh_imp_per: data.kvarh_imp_per || 0,
  }));

  if (!isLoggedIn) {

    return <Navigate to="/login" replace />;
  }
  return (
    <>
      <div id='main'>
        <Header />

        <Container fluid className='main my-3'>
          <Row>
            <Paper sx={{ height: 600, width: '100%' }}>
              <DataGrid
                rows={rows}
                columns={columns}
                pageSize={10}
                rowsPerPageOptions={[5, 10, 20]}

                disableSelectionOnClick
              />
            </Paper>
          </Row>
        </Container>
      </div>
    </>
  )
}

export default Invoice
